import { useLocation, useNavigate } from 'react-router-dom';
import { classes, stylesheet } from 'typestyle';
import { ADALONG_COLORS } from '../../styles';
import { UserPill } from '../UserPill';
import logo from '../../assets/img/site/logo_alone_white.png';

interface NavBarProps {
  active?: string;
}

interface NavItem {
  path: string;
  label: string;
}

const NAV_ITEMS: NavItem[] = [
  { path: '/users', label: 'USERS' },
  { path: '/administrators', label: 'ADMINISTRATORS' },
  { path: '/groups', label: 'GROUPS' },
  { path: '/crawling', label: 'CRAWLING' },
];

export function NavBar({ active }: NavBarProps) {
  const navigate = useNavigate();
  const location = useLocation();
  
  const currentPath = active || location.pathname;

  const handleNavigation = (path: string) => {
    navigate(path);
  };

  return (
    <nav className={sheet.navbar}>
      <div className={sheet.logo} onClick={() => navigate('/users')}>
        <img src={logo} className={sheet.logoImg} alt="Logo" />
        <span className={sheet.adminText}>Admin</span>
      </div>

      <div className={sheet.navItemsContainer}>
        {NAV_ITEMS.map((item) => (
          <button
            key={item.path}
            className={classes(
              sheet.navButton,
              currentPath === item.path ? sheet.navButtonActive : ''
            )}
            onClick={() => handleNavigation(item.path)}
          >
            {item.label}
          </button>
        ))}
      </div>

      <div className={sheet.accountSection}>
        <UserPill />
      </div>
    </nav>
  );
}

const sheet = stylesheet({
  navbar: {
    paddingTop: 25,
    paddingBottom: 10,
    paddingLeft: 13,
    paddingRight: 18,
    backgroundColor: ADALONG_COLORS.DARK_BLACK,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderBottom: `1px solid ${ADALONG_COLORS.LIGHT_BLACK}`,
    flexShrink: 0,
  },
  logo: {
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    gap: 12,
  },
  logoImg: {
    height: 60,
    padding: "15px 0 15px 15px"
  },
  adminText: {
    fontFamily: '"Public Sans", sans-serif',
    fontSize: 26,
    color: ADALONG_COLORS.LIGHT_WHITE,
  },
  navItemsContainer: {
    display: 'flex',
    flexDirection: 'row',
    gap: 10,
    alignItems: 'center',
    justifyContent: 'center',
    flex: 1,
  },
  navButton: {
    padding: '10px 22px',
    fontWeight: 'bold',
    fontSize: 14,
    color: ADALONG_COLORS.LIGHT_WHITE,
    backgroundColor: 'transparent',
    border: 'none',
    borderBottom: '3px solid transparent',
    cursor: 'pointer',
    transition: 'all 0.2s',
    fontFamily: '"Public Sans", sans-serif',
    $nest: {
      '&:hover': {
        borderBottomColor: ADALONG_COLORS.FLASH_BLUE,
      },
    },
  },
  navButtonActive: {
    borderBottomColor: ADALONG_COLORS.FLASH_BLUE,
  },
  accountSection: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
  },
});

export default NavBar;
